import component from './comparisonTableMixedSegments.vue'

export default component
